import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { Modal } from 'antd'
const { confirm } = Modal;

export default function (title, content, onCallback, cancelCallbak) {
  confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content,
    onOk() {
      onCallback && onCallback()
    },
    onCancel() {
      console.log('Cancel');
      cancelCallbak && cancelCallbak()
    }
  });
}
